import styled from 'styled-components';
import { vars, pxToRem } from '$util/theme';

const { neutral400, neutral600 } = vars.quantumverse.reskinColors;

export default styled.em`
  box-sizing: border-box;
  font-family: Jokker, sans-serif;
  font-style: normal;
  text-transform: uppercase;
  font-weight: 600;
  background-color: transparent;
  white-space: nowrap;

  /* Small (default) */
  font-size: ${pxToRem(14)};
  padding: 1px 6px;
  color: ${neutral400};
  border-radius: 4px;
  line-height: 18px;
  border: 2px solid;
  @media (-webkit-device-pixel-ratio: 2), (min-resolution: 2dppx) {
    line-height: 19px;
    border-width: 1.5px;
  }

  /* Medium */
  &.medium {
    line-height: inherit;
    @media (-webkit-device-pixel-ratio: 2), (min-resolution: 2dppx) {
      line-height: 25px;
    }
    height: 50px;
    padding: 4px 8px;
    color: ${neutral600};
  }
`;
